import styled from 'styled-components';
import { COLOR } from '@src/styles/color';
import { CLIP_HEIGHT } from '@src/constants/timeline';

// Fills a gap between clips; hidden until hovered (the tooltip carries the label).
export const StyledInsert = styled.button`
  position: absolute;
  top: 50%;
  height: ${CLIP_HEIGHT}px;
  transform: translateY(-50%);
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid ${COLOR.indigo[16]};
  border-radius: 8px;
  background: ${COLOR.white};
  color: ${COLOR.darkGray};
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.12s ease;

  &:hover {
    opacity: 1;
    background: ${COLOR.charcoal};
  }

  svg {
    font-size: 24px;
  }
`;
